export const accentColorDsfrTypes = [
  "default",
  "green-tilleul-verveine",
  "green-bourgeon",
  "green-emeraude",
  "green-menthe",
  "green-archipel",
  "blue-ecume",
  "blue-cumulus",
  "purple-glycine",
  "pink-macaron",
  "pink-tuile",
  "yellow-tournesol",
  "yellow-moutarde",
  "orange-terre-battue",
  "brown-cafe-creme",
  "brown-caramel",
  "brown-opera",
  "beige-gris-galet",
];

export const statusColorDsfrTypes = ["info", "success", "error", "warning", "new"];
